exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsection.el-drawer__body[data-v-03b47f76] {\n  overflow: scroll;\n}\n", ""]);

// exports
